/**
 * セーフユーティリティ.
 * 
 * @author Nakagawa_Michio@ogis-ri.co.jp
 * 
 */

/// <reference types="jquery" />
/// <reference types="jquery.validation" />

import { load } from 'recaptcha-v3';

/**
 * 二重送信を禁止したサブミット処理.
 *
 * @param event Jquery.ClickEvent
 */
export function submitSafe(event: JQuery.ClickEvent | MouseEvent): void {
  event.preventDefault();
  let button: JQuery<HTMLElement> = $(event.target);
  let form: JQuery<HTMLElement> = button.parents('form');
  button.css('pointer-events', 'none');
  if (form.valid()) {
    console.log('valid');
    form.submit();
  } else {
    console.log('invalid');
    button.css('pointer-events', 'auto');
  }
}

/**
 * reCAPTCHAのトークンをロードする.
 * 
 * @param sitekey サイトキー.
 * @param modelId モーダル画面ID.
 * @param tokenId トークンを設定するフィールドID.
 */
export function loadRecaptchaToeken(sitekey : any , modelId: String, tokenId: String): void {
    $(modelId).modal('show');
    load(sitekey).then((recaptcha) => {
        recaptcha.execute('login').then((token) => {
          console.log(token)
          $(tokenId).val(token);
          $(modelId).fadeOut("slow", () => {
              $(modelId).modal('hide');
          })
        }).catch((error) => {
            console.error(error)
        })
    }).catch((error) => {
        console.error(error)
    })
}

/**
 * 二重クリック防止処理.
 *
 * @param event Jquery.ClickEvent
 */
export function clickSafe(event: JQuery.ClickEvent | MouseEvent): void {
  event.preventDefault();
  $(":button").each(function (index: number, obj) {
    $(obj).css('pointer-events', 'none');
　});
}